import React, { Component } from "react";
import BamboraSvgIcon from "./bamboraSvgIcon";

class Spinner extends Component {
  render() {
    if (this.props.waiting) {
      return (
        <div className="spinner">
          <div className="spinner-left"></div>
          <div className="spinner-right"></div>
        </div>
      );
    }
    if (this.props.success) {
      return (
        <div className="spinner  spinner-full spinner-success">
          <div className="spinner-left"></div>
          <div className="spinner-right"></div>
          <BamboraSvgIcon icon="checkmark" className="fill-success in-spinner" />
        </div>
      );
    }

    return false;
  }
}

export default Spinner;
